import { makeStyles } from '@material-ui/core/styles'

import themesConfig from 'app/fuse-configs/themesConfig'

import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  dialogWrap: {
    '& .MuiPaper-root': {
      padding: '30px 20px',
      maxWidth: 554,
      width: '100%',
      [useBreakpoints(theme).lessThan.sm]: {
        padding: 10,
      },
      borderRadius: 16,
    },
  },

  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    padding: 0,
    color: themesConfig.default.colors.primary,
  },

  dialogTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: themesConfig.default.colors.primary,
    fontWeight: 700,
  },

  dialogContent: {
    color: themesConfig.default.colors['dove-gray'],
    marginBottom: 40,
    textAlign: 'center',
    padding: 0,
    fontSize: 14,
  },

  dialogActions: {
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    [useBreakpoints(theme).lessThan.sm]: {
      flexWrap: 'wrap',
    },
    '&  > :not(:first-child) ': {
      margin: 0,
    },
  },

  actionbutton1: {
    borderColor: themesConfig.default.colors.primary,
    color: themesConfig.default.colors.primary,
    '&:hover': {
      borderColor: themesConfig.default.colors.primary,
    },
  },
  actionbutton2: {
    backgroundColor: themesConfig.default.colors.primary,
    color: themesConfig.default.colors['primary-lighte'],
    '&:hover': {
      backgroundColor: themesConfig.default.colors.primary,
    },
  },
}))
